import script from "./EditLinkIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditLinkIcon.vue?vue&type=script&setup=true&lang=ts"

import "./EditLinkIcon.vue?vue&type=style&index=0&id=1cc2cf50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc2cf50"]])

export default __exports__